(function () {
  const root = document.querySelector('wishlist-page');
  if (!root) return;
  if (!window.SBSWishlist || !window.SBSWishlist.api) {
    document.addEventListener('wishlist:changed', boot, { once: true });
    return;
  }
  boot();

  async function boot() {
    // Await wishlist.js init() so localStorage/API data is populated before
    // the first render. Without this, render() can race ahead with an empty
    // items array and miss the wishlist:changed event from init().
    // Note: load order of these defer scripts is intentional — wishlist.js must
    // precede wishlist-page.js so that window.SBSWishlist.ready is assigned.
    if (window.SBSWishlist.ready) {
      try { await window.SBSWishlist.ready; } catch (e) {}
    }
    document.addEventListener('wishlist:changed', render);
    render();
  }

  function templateUrl(handle) {
    return root.getAttribute('data-fragment-url-template').replace('{handle}', encodeURIComponent(handle));
  }

  function clearChildren(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  function parseFragment(htmlString) {
    // Same-origin Shopify-rendered HTML from product-card-fragment section.
    // Parsed via DOMParser and appended as nodes (no innerHTML assignment of the response body).
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    const frag = document.createDocumentFragment();
    Array.from(doc.body.childNodes).forEach((n) => frag.appendChild(n));
    return frag;
  }

  let renderToken = 0;

  async function render() {
    const myToken = ++renderToken;
    const grid = root.querySelector('[data-wishlist-grid]');
    const empty = root.querySelector('[data-wishlist-empty]');
    const count = root.querySelector('[data-wishlist-count]');
    const items = window.SBSWishlist.api.getAll();

    if (!items.length) {
      grid.hidden = true;
      clearChildren(grid);
      empty.hidden = false;
      count.hidden = true;
      return;
    }

    empty.hidden = true;
    grid.hidden = false;

    const results = await Promise.all(items.map(async (it) => {
      try {
        const res = await fetch(templateUrl(it.handle));
        if (!res.ok) return { ok: false, item: it };
        const html = await res.text();
        return { ok: true, item: it, html };
      } catch (e) {
        return { ok: false, item: it };
      }
    }));

    if (myToken !== renderToken) return;

    const dead = results.filter((r) => !r.ok).map((r) => r.item.id);
    if (dead.length) {
      dead.forEach((id) => window.SBSWishlist.api.remove(id));
      return;
    }

    clearChildren(grid);
    results.forEach((r) => grid.appendChild(parseFragment(r.html)));

    const total = items.length;
    count.hidden = false;
    count.textContent = total === 1 ? '1 item' : total + ' items';
  }
})();
